import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../services/Api'

const documentosRepository = createRepository({
  parentPath: 'solicitacoes',
  path: 'documentos',
  relationType: 'path',
  restApi
})

documentosRepository.uploadDocumento = (solicitacaoId, data, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify(data))
  return restApi.post(`solicitacoes/${solicitacaoId}/documentos`, formData, {
    header: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

export default documentosRepository
